module.exports = __webpack_public_path__ + "static/img/vip_privilege7.ee581f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vip/vip_privilege7.png
// module id = /I0G
// module chunks = 0